import { Divider, Stack } from "@bvhi/ui-base";
import { UseFieldArrayRemove } from "react-hook-form";
import { CatalogsUpdateMatchingRulesBlockCard } from "./catalogs-update-matching-rules-block-card";

interface Props {
  fields: Record<"id", string>[];
  removeMatchingBlock: UseFieldArrayRemove;
  options: string[];
}

export const CatalogsUpdateMatchingRulesBlocks = ({ fields, options, removeMatchingBlock }: Props) => {
  return (
    <Stack spacing={2}>
      {fields.map((field, index) => {
        return (
          <>
            <Divider sx={{ mx: 8 }} />
            <CatalogsUpdateMatchingRulesBlockCard
              key={field.id}
              index={index}
              options={options}
              removeMatchingBlock={removeMatchingBlock}
            />
          </>
        );
      })}
    </Stack>
  );
};
